import { useOfflineSync } from "@/hooks/useOfflineSync";

// Headless component to enable background offline sync without any UI
export const BackgroundSyncManager = () => {
  // Initialize and keep the hook active for event listeners and sync
  useOfflineSync();
  return null;
};
